import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, inject, output } from "@angular/core";
import { HelpersService } from "../../../shared/helpers-service/helpers.service";
import { Subscription } from "rxjs";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { IFirmRolesService, UtilsService } from "src/app/shared";
import { AddEditComponent } from "@shared/index";

@Component({
    selector: "wk-setting-mapping-status",
    templateUrl: "./setting-mapping-status.component.html",
    styleUrl: "./setting-mapping-status.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
    host: { class: "wk-sm__status" },
})
export class SettingMappingStatusComponent implements OnDestroy {
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly helpersService = inject(HelpersService);
    private readonly modalService = inject(BsModalService);
    private readonly iFirmRolesService = inject(IFirmRolesService);

    roles: any;
    subscription: Subscription;
    bsModalRef?: BsModalRef;

    @Input() statusItem;
    @Input() isJobsBillingDashboard = false;
    readonly onFormChanged = output<boolean>();

    constructor() {
        const changeDetectorRef = this.changeDetectorRef;

        this.roles = [
            ...this.iFirmRolesService.iFirmRoles,
            {
                Description: {
                    "en-CA": "Unassigned",
                    "fr-CA": "Non assigné",
                },
                Id: "unassigned",
            },
        ];
        this.subscription = this.helpersService.langChangeEvent$.subscribe((event) => {
            changeDetectorRef.detectChanges();
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    editStep() {
        this.bsModalRef = this.modalService.show(AddEditComponent, {
            initialState: {
                title: "Settings.EditCustomizedStatuses",
                data: UtilsService.recursiveDeepCopy(this.statusItem.TaxReturnStatuse),
                callback: (aColumn) => this.onSave(aColumn),
            },
            class: "custom-modal-rename-dashboard",
        });
    }

    onSave(aColumn) {
        this.onFormChanged.emit(true);
        this.statusItem.TaxReturnStatuse.Name["en-CA"] = aColumn.Name["en-CA"];
        this.statusItem.TaxReturnStatuse.Name["fr-CA"] = aColumn.Name["fr-CA"];
        this.changeDetectorRef.detectChanges();
        this.bsModalRef.hide();
    }

    showTooltip(e: MouseEvent): void {
        const element = e.target as HTMLElement;
        if ((element.nodeName === "DIV" || element.className === "wk-mapping__status--title") && element.offsetWidth < element.scrollWidth) {
            element.setAttribute("data-title", element.innerText);
        }
    }
}
